module.exports = __webpack_public_path__ + "static/grassy-1-57ac9c0983601f52c09df610f649de77.jpg";